import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router"
import { targetRoutes } from "@/ts/routes/target-routes"

export const appRoutes: RouteRecordRaw[] = targetRoutes

const router = createRouter({
        history: createWebHistory(import.meta.env.BASE_URL),
        routes: appRoutes,
        scrollBehavior(to, _from, savedPosition) {
                if (savedPosition) return savedPosition
                if (to.name === "read") return false
                if (to.hash) return { el: to.hash, top: 24, behavior: "smooth" }

                return { top: 0 }
        },
})

if (import.meta.env.VITE_EBOOK_TARGET === "web") {
        const defaultTitle = document.title
        const bookTitles = new Map(import.meta.env.VITE_EBOOK_BOOK_TITLES ?? [])

        router.afterEach((to, _from, failure) => {
                if (failure) return

                const bookId = String(to.meta.bookId ?? to.params.bookId ?? "")
                const bookOverviewPath = router.options.history.state.bookOverviewPath
                const isAboutLandingPage = to.name === "about-ebook" && (typeof bookOverviewPath !== "string" || !bookOverviewPath.trim())
                document.title = isAboutLandingPage
                        ? "Электронные учебники АСТ-ПРЕСС ШКОЛА"
                        : typeof to.meta.title === "string" ? to.meta.title : bookTitles.get(bookId)?.trim() || defaultTitle
        })
}

export default router
